module.exports = __webpack_public_path__ + "static/img/banner-2.761e48aa.png";